import React, { useEffect, useRef, useState } from 'react';
import './ButtonImportSql.scss';

function ButtonImportSql({ handleClick, handleSqlClick, handleDbmlClick, handlePlaygroundClick }) {
    const [isOpen, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const handleOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener('mousedown', handleOutside);
        return () => document.removeEventListener('mousedown', handleOutside);
    }, []);

    const handleImportSql = () => {
        handleSqlClick();
        setOpen(false);
    };

    const handleImportDbml = () => {
        handleDbmlClick();
        setOpen(false);
    };

    const handleImportPlayground = () => {
        handlePlaygroundClick();
        setOpen(false);
    };

    return (
        <div ref={ref} className="btn-import-sql_wrap">
            <button
                type="button"
                className={`dash-main-header-button secondary ${isOpen ? 'hovered' : ''}`}
                onClick={(e) => { handleClick(e); setOpen((p) => !p); }}
            >
                <div className='left-part'>Import SQL</div>
                <div className='right-part'>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 9L12 15L18 9"></path></svg>
                </div>
            </button>

            {isOpen && (
                <ul className="btn-import-sql_menu">
                    <li className='btn-import-sql_menu-item'>
                        <button
                            type="button"
                            className="btn-import-sql_menu-item-btn"
                            onClick={(e) => { handleImportSql(e); }}
                        >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15M7 10L12 15M12 15L17 10M12 15V3"></path></svg>
                            Import SQL
                        </button>
                    </li>
                    <li className='btn-import-sql_menu-item'>
                        <button
                            type="button"
                            className="btn-import-sql_menu-item-btn"
                            onClick={(e) => { handleImportDbml(e); }}
                        >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15M7 10L12 15M12 15L17 10M12 15V3"></path></svg>
                            Import DBML
                        </button>
                    </li>
                    <li className='btn-import-sql_menu-item'>
                        <button
                            type="button"
                            className="btn-import-sql_menu-item-btn"
                            onClick={(e) => { handleImportPlayground(e); }}
                        >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15M7 10L12 15M12 15L17 10M12 15V3"></path></svg>
                            Import Playground
                        </button>
                    </li>
                </ul>
            )}
        </div>
    );
}


export default ButtonImportSql;
